import React from 'react';
import css from './ClientLogos.module.scss';

import Link from '@components/Link/Link';

const ClientLogos = () => {
  return (
    <section className={css.logos}>
      <p className={css.small} style={{ textAlign: 'center' }}>
        <mark>Ana is one of the thousands of founders</mark> who launched their marketplace with
        Sharetribe. <Link to="/customers/the-octopus-club/">Read her story ›</Link>
      </p>
      {/* <div className={css.logoCarousel}></div> */}
    </section>
  );
};

export default ClientLogos;
